import React from 'react';
import TableWithSorter from '../../../components/Common/TableWithSorter';
import { Space } from 'antd';
import { Link } from 'react-router-dom';

const CommunityEventTable = ({
  data,
  communities,
  totalData,
  onPaginationChange
}) => {
  const columns = [
    {
      title: 'Event Id',
      dataIndex: 'eventId',
      key: 'eventId'
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (text, record) => (
        <Space size="middle">
          <div>
            <Link to={`/community/event/${record._id}`}>
              {record?.title}
            </Link>
          </div>
        </Space>
      )
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type'
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      filters: [
        {
          text: 'Active',
          value: 'Active'
        },
        {
          text: 'Cancelled',
          value: 'Cancelled'
        }
      ]
    },
    {
      title: 'Is Active?',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (text, record) => {
        if (record?.isActive) return <span>true</span>;
        return <span>false</span>;
      }
    },
    {
      title: 'Start Time',
      dataIndex: 'startTime',
      key: 'startTime',
      sorter: (a, b) =>
        new Date(a.startTime).getTime() - new Date(b.startTime).getTime(),
      sortDirections: ['descend', 'ascend']
    },
    {
      title: 'End Time',
      dataIndex: 'endTime',
      key: 'endTime',
      sorter: (a, b) =>
        new Date(a.endTime).getTime() - new Date(b.endTime).getTime(),
      sortDirections: ['descend', 'ascend']
    },
    {
      title: 'Host',
      dataIndex: 'host',
      key: 'host',
      render: (text, record) => (
        <Space size="middle">
          <div>{record?.host?.firstName}</div>
          <div>{record?.host?.lastName}</div>
          <div>
            <span>
              <img
                alt="profileImg"
                width={50}
                height={50}
                style={{ borderRadius: '100%' }}
                src={record?.host?.profileImage}
              />
            </span>
          </div>
        </Space>
      )
    },
    {
      title: 'Communities',
      dataIndex: 'communities',
      key: 'communities',
      render: (text, record) => {
        const addedCommunities = record?.communities;
        const filterComm = communities?.filter(
          (c) => addedCommunities.indexOf(c._id) > -1
        );
        return (
          <div>
            {filterComm.map((c, index) => (
              <div key={index}>
                <Link to={`/community/${c._id}`}>{c.code}</Link>
              </div>
            ))}
          </div>
        );
      }
    },
    {
      title: 'Card Image',
      dataIndex: 'cardImgData',
      key: 'cardImgData',
      render: (text, record) => (
        <Space size="middle">
          {record?.cardImgData?.mobileImgData?.src && (
            <div>
              <img
                alt="profileImg"
                width={50}
                height={50}
                src={record?.cardImgData?.mobileImgData?.src}
              />
            </div>
          )}
        </Space>
      )
    },
    {
      title: 'Live link',
      dataIndex: 'liveLink',
      key: 'liveLink'
    },
    {
      title: 'Recording link',
      dataIndex: 'recordingLink',
      key: 'recordingLink'
    }
  ];

  return (
    <div className="community-events-table">
      <TableWithSorter
        tableLayout="auto"
        scroll={{ x: 1000 }}
        expandable={{ defaultExpandAllRows: true }}
        dataSource={data}
        columns={columns}
        pagination={{
          total: totalData,
          defaultPageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '50']
        }}
        onChange={onPaginationChange}
      />
    </div>
  );
};

export default CommunityEventTable;
